module.exports = __webpack_public_path__ + "static/media/heart.502189ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/heart.svg
// module id = 371
// module chunks = 0